import { Directive, ElementRef, AfterViewInit, Input } from '@angular/core';
import { VersionService } from '../service/version.service';

@Directive({
  selector: '[appVersion]',
  standalone: true
})
export class VersionDirective implements AfterViewInit {
  @Input() appVersion: string = '';

  constructor(
    private el: ElementRef,
    private versionService: VersionService
  ) {}

  ngAfterViewInit() {
    const element = this.el.nativeElement;

    if ((element.tagName === 'IMG' ||
         element.tagName === 'SCRIPT' ||
         element.tagName === 'SOURCE') && element.src) {
      setTimeout(() => {
        element.src = this.versionService.addVersion(element.src);
      });
    }
    if (element.tagName === 'A' && element.href) {
      setTimeout(() => {
        element.href = this.versionService.addVersion(element.href);
      });
    }
  }
}
